import { selectors } from '../';
import { ITEM_DEFINITION_CODES, ITEM_STATUSES, STATES } from '../../constants';
import {
  itemStatusesByKind,
  statusFromItems,
} from '../../components/dashboard/dashboard.utils.js';
import { intersection } from 'lodash-es';

export const currentStep = ({ step }) => step && step.current;

export const nextStep = state =>
  deriveNextStep({
    currentStep: currentStep(state),
    filteredNextStepsList: nextSteps(state),
  });

export const nextSteps = state => {
  const personalization = chosenSteps(state) || [];
  return orderedAvailableItemKinds(state).filter(
    kind => personalization.length === 0 || personalization.includes(kind)
  );
};

export const isTerminalRoute = ({ step }) => step && step.isTerminalRoute;
export const chosenSteps = ({ step }) => step && step.chosenSteps;
export const isLastStep = state =>
  state?.step && nextStep(state) === STATES.DASHBOARD;

export const nextStepsList = [
  ITEM_DEFINITION_CODES.HOME_SERVICE_APP,
  ITEM_DEFINITION_CODES.FORWARD_MAIL,
  ITEM_DEFINITION_CODES.PROMOTION,
  ITEM_DEFINITION_CODES.UTILITY,
  ITEM_DEFINITION_CODES.INSURANCE,
  ITEM_DEFINITION_CODES.MOVEIQ,
  ITEM_DEFINITION_CODES.SMART_HOME_OWN,
  ITEM_DEFINITION_CODES.UPDATE_ACCOUNT,
];

function orderedAvailableItemKinds(state) {
  const itemStatuses = itemStatusesByKind(state);
  return selectors.itemDefinition
    .all(state)
    .map(({ code }) => code(state))
    .filter(code => nextStepsList.includes(code))
    .sort((a, b) =>
      nextStepsList.indexOf(a) > nextStepsList.indexOf(b) ? 1 : -1
    )
    .filter(isItemStillInDaisyChain(itemStatuses, state));
}

const isItemStillInDaisyChain = (itemStatuses, state) => code => {
  // Logic modeled off of logic in the dashboard see dashboard.component.js
  if (!itemStatuses[code]) return true;
  const move = selectors.current.move(state);
  if (move.declinedStatusByCode(code, state)) return false;

  const { status } = statusFromItems(itemStatuses[code]);
  return (
    status !== ITEM_STATUSES.COMPLETED &&
    status !== ITEM_STATUSES.PENDING &&
    status !== ITEM_STATUSES.VALIDATING &&
    status !== ITEM_STATUSES.CANCELLED &&
    status !== ITEM_STATUSES.RESERVED &&
    status !== ITEM_STATUSES.NOT_NEEDED &&
    status !== ITEM_STATUSES.CALLED
  );
};

function deriveNextStep({ currentStep, filteredNextStepsList }) {
  if (filteredNextStepsList.length === 0) {
    return STATES.DASHBOARD;
  }

  // What's left of the static list
  let possibleRemainingSteps = nextStepsList.slice(
    nextStepsList.indexOf(currentStep) + 1
  );
  // What's left of that when filtered
  let actualRemainingSteps = intersection(
    possibleRemainingSteps,
    filteredNextStepsList
  );
  // The first remaining step will be the next step
  let nextStep = actualRemainingSteps[0];

  return nextStep || STATES.DASHBOARD;
}
